import { render } from "./HeroItem.vue?vue&type=template&id=644072d7&scoped=true"
import script from "./HeroItem.vue?vue&type=script&setup=true&lang=js"
export * from "./HeroItem.vue?vue&type=script&setup=true&lang=js"

import "./HeroItem.vue?vue&type=style&index=0&id=644072d7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-644072d7"],['__file',"src/components/Paragraphs/HeroItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "644072d7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('644072d7', __exports__)) {
    api.reload('644072d7', __exports__)
  }
  
  module.hot.accept("./HeroItem.vue?vue&type=template&id=644072d7&scoped=true", () => {
    api.rerender('644072d7', render)
  })

}


export default __exports__